import { useState, useEffect } from 'react';
import { Grid, Box, Typography } from '@mui/material';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import ShareIcon from '@mui/icons-material/Share';
import DownloadIcon from '@mui/icons-material/Download';
import axios from 'axios';
import { useSelector } from 'react-redux';

export default function AssetViewerActionImpl() {
  const { mfproductObj } = useSelector((state) => state.manufslice.mfproductDashboard);
  const [assetsList, setAssetsList] = useState([]);
  const [mainAsset, setMainAsset] = useState(null);

  useEffect(() => {
    if (mfproductObj?.id) {
      axios
        .get(`https://api.manuf.appmachine.in/extn/assetss/productid/${mfproductObj.id}/productid`)
        .then(res => {
          setAssetsList(res.data.list || []);
          if (res.data.list && res.data.list.length > 0) setMainAsset(res.data.list[0]);
        });
    }
  }, [mfproductObj]);

  const isVideo = (path) => /\.(mp4|webm|ogg|mov|mkv)$/i.test(path);

  return (
    <Box sx={{ width: '100%',  display: 'flex', flexDirection: 'column' }}>
      {/* Main Area */}
      <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 1 }}>
        <Box sx={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          {mainAsset ? (
            <Box sx={{ position: 'relative', width: '90vw', height: '65vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              {/* Download Icon at top left */}
              <DownloadIcon
                sx={{
                  position: 'absolute',
                  top: 16,
                  left: 24,
                  color: 'primary.main',
                  fontSize: 36,
                  cursor: 'pointer',
                  background: 'rgba(255,255,255,0.7)',
                  borderRadius: '50%',
                  p: 0.5,
                  zIndex: 2
                }}
                onClick={() => {
                  const link = document.createElement('a');
                  link.href = mainAsset.path;
                  link.download = mainAsset.title || 'asset';
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                }}
              />
              {/* Share Icon at top right */}
              <ShareIcon
                sx={{
                  position: 'absolute',
                  top: 16,
                  right: 24,
                  color: 'primary.main',
                  fontSize: 36,
                  cursor: 'pointer',
                  background: 'rgba(255,255,255,0.7)',
                  borderRadius: '50%',
                  p: 0.5,
                  zIndex: 2
                }}
                onClick={() => {
                  if (navigator.share) {
                    navigator.share({
                      title: mainAsset.title || 'Asset',
                      text: 'Check out this asset!',
                      url: mainAsset.path
                    });
                  } else {
                    navigator.clipboard.writeText(mainAsset.path);
                    alert('Link copied to clipboard');
                  }
                }}
              />
              {isVideo(mainAsset.path) ? (
                <>
                  <video
                    src={mainAsset.path}
                    controls
                    autoPlay
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'contain',
                      borderRadius: 8,
                      background: '#fafafa'
                    }}
                  />
                  <PlayCircleOutlineIcon
                    sx={{
                      position: 'absolute',
                      top: 8,
                      left: 8,
                      color: '#fff',
                      fontSize: 32,
                      opacity: 0.7,
                      pointerEvents: 'none'
                    }}
                  />
                </>
              ) : (
                <img
                  src={mainAsset.path}
                  alt={mainAsset.title}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                    borderRadius: 8,
                    background: '#fafafa'
                  }}
                />
              )}
            </Box>
          ) : (
            <Typography variant="h6" color="text.secondary">No asset selected</Typography>
          )}
        </Box>
      </Box>
      {/* Asset List Row - Horizontally scrollable */}
      <Box
        sx={{
          
          overflowX: 'auto',
          overflowY: 'hidden',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          bgcolor: '#fff',
          borderTop: '1px solid #e0e0e0',
          boxShadow: '0 -2px 8px rgba(25,118,210,0.04)',
          borderRadius: 2,
          minHeight: 100,
          maxWidth: '90vw', // Ensure it doesn't overflow parent
        }}
      >
        {assetsList.map(assetObj => (
          <Box
            key={assetObj.id}
            sx={{
              width: 80,
              height: 80,
              borderRadius: 2,
              overflow: 'hidden',
              background: mainAsset?.id === assetObj.id ? '#e3f2fd' : '#fff',
              border: mainAsset?.id === assetObj.id ? '2px solid #1976d2' : '1px solid #e0e0e0',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
              position: 'relative',
              mx: 1,
              flex: '0 0 auto'
            }}
            onClick={() => setMainAsset(assetObj)}
            title={assetObj.title}
          >
            {isVideo(assetObj.path) ? (
              <>
                <video
                  src={assetObj.path}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    borderRadius: 8,
                    background: '#fafafa'
                  }}
                  muted
                  preload="metadata"
                />
                <PlayCircleOutlineIcon
                  sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    color: '#fff',
                    fontSize: 32,
                    opacity: 0.8,
                    pointerEvents: 'none'
                  }}
                />
              </>
            ) : (
              <img
                src={assetObj.path}
                alt={assetObj.title}
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  borderRadius: 8,
                  background: '#fafafa'
                }}
              />
            )}
          </Box>
        ))}
      </Box>
    </Box>
  );
}